export default (element?: Element | HTMLElement | null): boolean =>
  Boolean(
    element &&
      (('isContentEditable' in element && element.isContentEditable) ||
        ['input', 'select', 'textarea'].includes(element.tagName.toLowerCase())),
  );
